/**
 * @generated SignedSource<<6bc0203eca174d19e93136aaa69effb5>>
 * @relayHash 82bc2ef57083f105c3a75af0d16ccbb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74ec5247503ef80b21ba3b3cd1d14d9a5bd5e08ee3493586655d4540aac64f4e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_globalPermissionsAndGrantsQuery$variables = {
  cloudId: string;
};
export type main_globalPermissionsAndGrantsQuery$data = {
  readonly jira: {
    readonly globalPermissionsAndGrants: {
      readonly " $fragmentSpreads": FragmentRefs<"grantPermissionModal_globalPermissions_GrantPermissionDialog" | "main_globalPermissions_GlobalPermissionsTable_globalPermissionGrantsListRef">;
    };
  };
};
export type main_globalPermissionsAndGrantsQuery = {
  response: main_globalPermissionsAndGrantsQuery$data;
  variables: main_globalPermissionsAndGrantsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_globalPermissionsAndGrantsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "globalPermissionsAndGrants",
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "getGlobalPermissionsAndGrants",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "main_globalPermissions_GlobalPermissionsTable_globalPermissionGrantsListRef"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "grantPermissionModal_globalPermissions_GrantPermissionDialog"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.globalPermissionsAndGrants"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_globalPermissionsAndGrantsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "globalPermissionsAndGrants",
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "getGlobalPermissionsAndGrants",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraGlobalPermissionGrants",
                    "kind": "LinkedField",
                    "name": "globalPermissionGrants",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraGlobalPermission",
                        "kind": "LinkedField",
                        "name": "permission",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isManagedByJira"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "groups",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "groupId"
                          },
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraGlobalPermissionGrantsList"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "74ec5247503ef80b21ba3b3cd1d14d9a5bd5e08ee3493586655d4540aac64f4e",
    "metadata": {},
    "name": "main_globalPermissionsAndGrantsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e6a6814f30a2905d884e00d0e46d4977";

export default node;
